export const emoticonMap = Object.freeze([
  { emoticon: 1, label: "Thumbs up", emoji: "👍" },
  { emoticon: 2, label: "Heart", emoji: "❤️" },
  { emoticon: 3, label: "Loving", emoji: "🥰" },
  { emoticon: 4, label: "Sad", emoji: "😢" },
  { emoticon: 5, label: "Amazed", emoji: "😲" },
  { emoticon: 6, label: "Angry", emoji: "😡" },
]);